import { Box, Grid } from '@mui/material'
import SectionTitle from 'components/atoms/SectionTitle'
import _ from 'lodash'
import { FC} from 'react'
import { useTranslation } from 'react-i18next'
import { useGET_mySchoolQuery } from 'redux/api/mySchoolApi'
import { PRIMARY_BLUE, PRIMARY_GREEN, PRIMARY_LIGHT_BLUE, PRIMARY_LIGHT_GREEN } from 'utils/customizedTheme'
import { GOALBANK_ITEM_TYPES, goalbankSelectionItems, goalbankSelectionStandards, toHtml } from 'utils/helpers'

interface IProps {
    goalbankSelection: any,
    curriculumSelection: any
}

const GoalbankSelection: FC<IProps> = ({ goalbankSelection, curriculumSelection }) => {
    const { t } = useTranslation()
    const { isFetching: schoolLoading, data: schoolData } = useGET_mySchoolQuery()


    return <>

      {goalbankSelection && Object.keys(goalbankSelection).length > 0 &&

            <div style={{ 
              padding: '20px',
              marginBottom: '20px',
              borderRadius: '20px',
              backgroundColor: PRIMARY_LIGHT_GREEN,
              border: `2px solid ${PRIMARY_GREEN}` 
            }}>

                <Grid container spacing={4}>
                  {schoolData  &&  <Grid item xs={12} lg={4}>
                      <SectionTitle hasBackground={false} text={schoolData.curriculum ? t(`school-curriculum.${schoolData.curriculum}`) : t('curriculum')} />
                      <Box mt={2} className="transparent-background">{ goalbankSelectionStandards(goalbankSelection).join(", ") }</Box>
                    </Grid>  
                  }


                  {
                    Object.keys(GOALBANK_ITEM_TYPES)
                      .filter(section => 
                          goalbankSelectionItems(goalbankSelection, section).length>0)
                      .map(section => 
                         <Grid item xs={12} lg={4} key={`${section}`}>
                          <SectionTitle hasBackground={false} text={`${GOALBANK_ITEM_TYPES[section].title}`} />
                          <Box mt={2} className="transparent-background">
                            {
                              GOALBANK_ITEM_TYPES[section].type === 'units' 
                              ? <>
                                { goalbankSelectionItems(goalbankSelection, section)
                                    .sort((a,b) => a.sort_order - b.sort_order)
                                    .map(unit => 
                                  <div key={`unit_${unit.id}`} style={{ 
                                      borderBottom: '1px dashed gray',
                                      paddingBottom: '20px',
                                      marginBottom: '20px' 
                                    }}>
                                    <div>{unit.sort_order}. {unit.title}</div>

                                    {goalbankSelectionItems(goalbankSelection, "course_chapters")
                                      .filter(item => item.unit === unit.id).length > 0 &&
                                      <div style={{ marginTop: '20px', }}>
                                        <div>{t('goalbank.learning-progression')}:</div>
                                        <ul>{ goalbankSelectionItems(goalbankSelection, "course_chapters")
                                          .filter(item => item.unit === unit.id)
                                          .map(item => 
                                        <li key={`lesson_objective_${item.id}`}>{item.title} - {item.goal_code}</li>) 
                                        }
                                        </ul>
                                      </div>
                                    }
                                  </div>
                                )}
                              </>
                              : <ul>{ goalbankSelectionItems(goalbankSelection, section).map(item => 
                                <li key={item.id}>
                                  
                                  {GOALBANK_ITEM_TYPES[section]["code_field"] && 
                                  item[GOALBANK_ITEM_TYPES[section]["code_field"]] && 
                                  <b>({item[GOALBANK_ITEM_TYPES[section]["code_field"]]}) </b>}

                                  {item.title}

                                  {GOALBANK_ITEM_TYPES[section].display_code && <> - {item.goal_code}</>}

                                  

                                  {GOALBANK_ITEM_TYPES[section].has_description && item.description && <div>
                                    {/* Rich-text descriptions are HTML; generated ones (e.g. SLO) are plain text with one field per line */}
                                    {/<[a-z][\s\S]*>/i.test(item.description)
                                      ? <i dangerouslySetInnerHTML={toHtml(item.description)} />
                                      : <i style={{ whiteSpace: 'pre-line', display: 'block', fontSize: '14px' }}>{item.description}</i>}
                                    </div>}
                                </li>) }</ul>
                            }
                           
                          </Box>
                        </Grid>  
                    )
                  }
                </Grid>
     </div>} 
     

     {curriculumSelection && Object.keys(curriculumSelection).length > 0 &&
            <div style={{ 
              marginBottom: '20px',
              padding: '20px',
              borderRadius: '20px',
              backgroundColor: PRIMARY_LIGHT_BLUE,
              border: `2px solid ${PRIMARY_BLUE}` 
            }}>

                <Grid container spacing={4}>
                  {
                    Object.keys(GOALBANK_ITEM_TYPES)
                      .filter(section => 
                        goalbankSelectionItems(curriculumSelection, section).length>0)
                      .map(section => 
                         <Grid item xs={12} lg={4} key={`${section}`}>
                          <SectionTitle hasBackground={false} text={`${GOALBANK_ITEM_TYPES[section].title}`} />
                          <Box mt={2} className="transparent-background">
                              <ul>{ goalbankSelectionItems(curriculumSelection, section).map(item => 
                                <li key={item.id}>
                                  {GOALBANK_ITEM_TYPES[section]["code_field"] && 
                                  item[GOALBANK_ITEM_TYPES[section]["code_field"]] && 
                                  <b>({item[GOALBANK_ITEM_TYPES[section]["code_field"]]}) </b>}

                                  {item.title}

                                  {GOALBANK_ITEM_TYPES[section].has_description && item.description && <div>
                                      <i dangerouslySetInnerHTML={toHtml(item.description)} />
                                    </div>}
                                </li>) }
                              </ul>
                          </Box>
                        </Grid>  
                    )
                  }
                </Grid>
     </div> }

  </>
}

export default GoalbankSelection
